import React, { useState, useEffect } from "react";
import { useNavigation } from "context/NavigationContext";
import {
  BringzzPageContainer,
  BringzzButton,
  BringzzIcon,
  BringzzText,
  BringzzInput,
  BringzzDropdown,
  BringzzCountryDropdown
} from "@bringzz/components";
import useUser from "hooks/useUser";
import useRequest from "hooks/useRequest";

const roles = [
  { value: "PKA", label: "PKA" },
  { value: "PTA", label: "PTA" },
];

const AddPharmacyEmployee = () => {
  const { backPress, navigate } = useNavigation();
  const { sendRequest, loading } = useRequest();
  const { getUser } = useUser();
  const loggedInUser = getUser();

  const [pharmacyId, setPharmacyId] = useState("");
  const [bio, setBio] = useState("");
  const [login, setLogin] = useState("");
  const [loginType, setLoginType] = useState(null);
  const [role, setRole] = useState("PKA");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [country, setCountry] = useState('');
  const [isValidInput, setIsValidInput] = useState(false);

  useEffect(() => {
    const fetchPharmacyId = async () => {
      try {
        const response = await sendRequest({
          method: "GET",
          url: "/module/pharmacyteam/getPharmacyId",
        });

        if (response?.status === "success") {
          setPharmacyId(response.data.pharmacyId);
        } else {
          setErrorMessage(response?.message || "Failed to fetch pharmacy ID.");
        }
      } catch (error) {
        console.error("Error fetching pharmacy ID:", error);
        setErrorMessage("An error occurred while fetching pharmacy ID.");
      }
    };

    fetchPharmacyId();
  }, [sendRequest]);

  const handleLoginChange = (newValue) => {
    setLogin(newValue);
    if (/^\+?\d{1,3}[-\s.]?\d{3,}/.test(newValue)) {
      setLoginType(1);
    } else if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newValue)) {
      setLoginType(0);
    } else {
      setLoginType(null);
    }
  };

  const handleSubmit = async () => {
    if (!bio.trim() || !login.trim() || loginType === null || !firstName.trim() || !lastName.trim()) {
      setErrorMessage("Please fill in all the required fields correctly.");
      return;
    }

    try {
      const response = await sendRequest({
        method: "POST",
        url: "/module/pharmacyteam/addPharmacyTeamMember",
        data: {
          data: {
            pharmacyId: parseInt(pharmacyId),
            bio,
            login,
            logintype: loginType,
            role,
            firstName: firstName,
            lastName: lastName,
            created_by_id: loggedInUser.id,
          },
        },
      });

      if (response?.status === "success") {
        navigate("/settings/pharmacy/team", false);
      } else {
        setErrorMessage(
          response?.message || "An error occurred. Please try again."
        );
      }
    } catch (error) {
      console.error("Error adding pharmacy employee:", error);
      setErrorMessage("An error occurred. Please try again.");
    }
  };

  return (
    <BringzzPageContainer
      header={{
        left: (
          <BringzzIcon
            size="22"
            icon="IconChevronLeft"
            folder="LineIcons"
            className="cursor-pointer"
            onClick={backPress}
          />
        ),
        title: <BringzzText tag="h2">Add Employee</BringzzText>,
      }}
      footer={
        <div className="pb-28 px-6">
          <BringzzButton
            size="lg"
            className="bg-magic-lilac w-full flex justify-center text-midnight-blue"
            onClick={handleSubmit}
            disabled={loading}
          >
            Add Employee
          </BringzzButton>
        </div>
      }
    >
      <div className="p-6 space-y-4">
        {errorMessage && (
          <BringzzText tag="h3" className="text-red-500">
            {errorMessage}
          </BringzzText>
        )}

        <div className="flex mt-6">
          <BringzzInput
            containerClassname="w-full"
            className="!pl-16"
            type="text"
            placeholder="Phone Number or Email"
            value={login}
            onChange={(e, isValid, newValue) => {
              handleLoginChange(newValue);
              setIsValidInput(isValid);
            }}
            pattern="^(?:\+?\d{1,3}[-\s.]?\d{3,}|\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+)$"
            icon={{
              left: (
                <BringzzCountryDropdown
                  className="!rounded-r-none"
                  mode={"modal"}
                  onCountryChange={(result) => {
                    setCountry(result);
                  }}
                />
              ),
            }}
          />
        </div>
        <div>
          <BringzzText tag="label" className="block mb-1">
            First Name
          </BringzzText>
          <BringzzInput
            placeholder="Enter First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>

        <div>
          <BringzzText tag="label" className="block mb-1">
            Last Name
          </BringzzText>
          <BringzzInput
            placeholder="Enter Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>

        <div>
          <BringzzText tag="label" className="block mb-1">
            Role
          </BringzzText>
          <BringzzDropdown
            options={roles}
            defaultValue={role}
            onChange={(value) => setRole(value)}
            className="w-full mb-2"
          />
        </div>
        <div>
          <BringzzText tag="label" className="block mb-1">
            Bio
          </BringzzText>
          <BringzzInput
            placeholder="Enter Employee Bio"
            value={bio}
            onChange={(e) => setBio(e.target.value)}
          />
        </div>
      </div>
    </BringzzPageContainer>
  );
};

export default AddPharmacyEmployee;
